/* eslint-disable no-eval */
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import tem from 'template_js';
export default {
  data: function data() {
    return {
      usedWidth: 0,
      percentReg: new RegExp('^(100|[1-9]\\d|\\d)(.\\d{1,2})?%$')
    };
  },

  methods: {
    cal_col_width: function cal_col_width(width, num) {
      // 计算列宽
      if (this.is_real_num(num)) {
        return parseInt(num);
      } else if (this.is_percent_num(num)) {
        var sNum = num.replace('%', '');
        return width * sNum / 100;
      }
      return -1;
    },
    is_percent_num: function is_percent_num(num) {
      // 验证数字类型 是否是百分比
      return this.percentReg.test(num);
    },
    is_real_num: function is_real_num(num) {
      // 验证是否是数字
      if (num === '' || num == null) {
        return false;
      } else if (!isNaN(num)) {
        return true;
      }
      return false;
    },
    array_index: function array_index(arr, key) {
      for (var i = 0, len = arr.length; i < len; i++) {
        if (arr[i] === key) {
          return i;
        }
      }
      return -1;
    },
    rowClassName: function rowClassName(row, index) {
      var func = 'function test(row, index){console.log(index)}';
      var fn = void 0;
      eval('fn=' + func);
      fn(row, index);
      return '';
    },
    template: function template(tpl, data) {
      tem.config({ sTag: '{{', eTag: '}}', escape: true });
      return tem(tpl, data);
    },
    notEmpty: function notEmpty(data) {
      if (data && data.length > 0) {
        return true;
      }
      return false;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/mixins/methods.js
// module id = 58
// module chunks = 0